export default __webpack_public_path__ + "static/media/Cyber-Extortion.41cb2e07.png";